import { ItemSaldoResponse } from '../@types/item-saldo';
import aqilaApi from './aqila-api';

class ItensEstoque {
  private readonly endpoint = '/v1/itens/saldo';

  async saldos(propriedadeId?: number, descricao?: string) {
    const { data } = await aqilaApi.get<ItemSaldoResponse[]>(this.endpoint, {
      params: {
        propriedade: propriedadeId,
        descricao,
      },
    });

    return data;
  }
}

export default new ItensEstoque();
